module.exports = __webpack_public_path__ + "static/img/SourceSansPro-Regular.33e24d9.svg";